import { CURRENT_USERNAME, LINKS_SURVEY_ADMIN_ENTRY, ROLES } from "../../../ducks/login";
import {
  hidePreviewSurvey,
  loadSurvey,
  loadSurveyVersion,
  previewSurvey,
  resetSurvey,
  SHOW_SURVEY_PREVIEW,
  SURVEY_LANGUAGE,
  SURVEY_NAME,
  surveyVersionCompare
} from "../../../ducks/survey";
import { copySurveyTemplate, loadReportingPeriods, loadSurveySettings, newSurvey } from "../../../ducks/surveySettings";
import {
  activateTemplate,
  ACTIVATION_HISTORY,
  closeActivationInfoDialog,
  closeQuestionSyncDialog,
  closeTemplateActivationDialog,
  deleteTemplate,
  deleteTemplateVersion,
  LOADED,
  loadHistory,
  loadTemplateListFilter,
  publishSurvey,
  questionSync,
  synchronizeTemplateVersion,
  SHOW_ACTIVATION_DIALOG,
  SHOW_ACTIVATION_INFO_DIALOG,
  SHOW_HISTORY,
  SHOW_SYNC_DIALOG,
  showActivationInfoDialog,
  SORT_TABLE_TEMPLATE,
  SORT_TABLE_TEMPLATE_ASCENDING,
  SORT_TABLE_TEMPLATE_BY,
  sortColumn,
  TEMPLATE_FOR_ACTIVATION,
  TEMPLATE_HISTORY,
  TEMPLATE_LIST
} from "../../../ducks/templatelist";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PAGES_KEY } from "../../../common/constant";
import { showDialog } from "../../../ducks/confirmDialog";
import { loadAllData } from "../../../ducks/indicatorManagament";
import { propertyChange } from "../../../ducks/surveyView";
import TemplateList from "./TemplateList";

const mapStateToProps = (state) => {
  return {
    templateList: state.templatelist[TEMPLATE_LIST],
    surveyAdminLink: state.login[LINKS_SURVEY_ADMIN_ENTRY],
    roles: state.login[ROLES],
    currentUsername: state.login[CURRENT_USERNAME],
    showHistory: state.templatelist[SHOW_HISTORY],
    templateHistory: state.templatelist[TEMPLATE_HISTORY],
    activationHistory: state.templatelist[ACTIVATION_HISTORY],
    sortTableTemplate: state.templatelist[SORT_TABLE_TEMPLATE],
    sortTableTemplateBy: state.templatelist[SORT_TABLE_TEMPLATE_BY],
    sortTableTemplateAscending: state.templatelist[SORT_TABLE_TEMPLATE_ASCENDING],
    [TEMPLATE_FOR_ACTIVATION]: state.templatelist[TEMPLATE_FOR_ACTIVATION],
    [SHOW_ACTIVATION_DIALOG]: state.templatelist[SHOW_ACTIVATION_DIALOG],
    showSyncDialog: state.templatelist[SHOW_SYNC_DIALOG],
    loaded: state.templatelist[LOADED],
    showActivationInfo: state.templatelist[SHOW_ACTIVATION_INFO_DIALOG],
    surveyName: state.survey[SURVEY_NAME],
    surveyLanguage: state.survey[SURVEY_LANGUAGE],
    showSurveyPreview: state.survey[SHOW_SURVEY_PREVIEW],
    editorPages: state.surveyEditor[PAGES_KEY]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      deleteTemplate,
      loadSurvey,
      resetSurvey,
      loadSurveyVersion,
      loadTemplateListFilter,
      copySurveyTemplate,
      loadSurveySettings,
      surveyVersionCompare,
      newSurvey,
      showDialog,
      loadHistory,
      sortColumn,
      publishSurvey,
      loadReportingPeriods,
      deleteTemplateVersion,
      activateTemplate,
      showActivationInfoDialog,
      questionSync,
  synchronizeTemplateVersion,
      closeTemplateActivationDialog,
      closeActivationInfoDialog,
      closeQuestionSyncDialog,
      hidePreviewSurvey,
      previewSurvey,
      propertyChange,
      loadAllData
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateList);
